import { render } from "./DelivryOrdersActionMenu.vue?vue&type=template&id=6abde91e&scoped=true"
import script from "./DelivryOrdersActionMenu.vue?vue&type=script&lang=js"
export * from "./DelivryOrdersActionMenu.vue?vue&type=script&lang=js"

import "./DelivryOrdersActionMenu.vue?vue&type=style&index=0&id=6abde91e&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abde91e"]])

export default __exports__